// extracted by mini-css-extract-plugin
export default {"description":"ServecesBlock_description__dFYFL","btn":"ServecesBlock_btn__di58m"};